module.exports = __webpack_public_path__ + "img/hero-2.438d810.svg";